import {
  SET_DEV_TICKETS,
  SET_DEV_PAGE,
  SET_DEV_VERSION,
  SET_DEV_FILTER,
  SET_DEV_HASH,
  SET_VERSIONS,
  SET_LOADING,
  TicketsActionTypes,
  DevelopmentFilter,
} from './Types';
import {Page} from '../../Models';
import {DevelopmentTicket} from '../../Services/TicketService';
import {ThunkResult} from '../index';
import {IHttpResponse} from '../../Services/Service';

export const setDevelopmentTickets = (tickets: Page<DevelopmentTicket>): TicketsActionTypes => {
  return {
    type: SET_DEV_TICKETS,
    payload: tickets,
  };
};

export const setDevelopmentPage = (page: number): TicketsActionTypes => {
  return {
    type: SET_DEV_PAGE,
    payload: page,
  };
};

export const setDevelopmentVersion = (version: string): TicketsActionTypes => {
  return {
    type: SET_DEV_VERSION,
    payload: version,
  };
};

export const setDevelopmentFilter = (filter: DevelopmentFilter): TicketsActionTypes => {
  return {
    type: SET_DEV_FILTER,
    payload: filter,
  };
};

export const setDevelopmentHash = (hash: string): TicketsActionTypes => {
  return {
    type: SET_DEV_HASH,
    payload: hash,
  };
};

export const setVersions = (versions: string[]): TicketsActionTypes => {
  return {
    type: SET_VERSIONS,
    payload: versions,
  };
};

export const setLoading = (loading: boolean): TicketsActionTypes => {
  return {
    type: SET_LOADING,
    payload: loading,
  };
};

export const loadDevelopmentCreator = (page: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {
      auth: {
        ticketService,
      },
      tickets: {
        development: {
          currentFilter,
          currentPage,
          currentVersion,
        },
      },
    } = getState();

    if (page === currentPage) {
      return;
    }

    const requestHash = `${currentFilter}-${page}-${currentVersion}`;
    dispatch(setDevelopmentHash(requestHash));

    let fetcher: Promise<IHttpResponse<Page<DevelopmentTicket>>>;
    switch (currentFilter) {
    case 'All':
      fetcher = ticketService.listAllDevelopment(page);
      break;
    case 'Unreleased':
      fetcher = ticketService.listUnreleasedDevelopment(page);
      break;
    case 'Version':
      fetcher = ticketService.listDevelopmentByVersion(page, currentVersion);
      break;
    default:
      return;
    }

    dispatch(setLoading(true));

    try {
      const res = await fetcher;
      if (res.parsedBody !== undefined) {
        const {tickets: {development: {requestHash: currentHash}}} = getState();
        console.log(requestHash, currentHash);
        if (requestHash === currentHash) {
          dispatch(setDevelopmentTickets(res.parsedBody));
          dispatch(setDevelopmentPage(page));
        }
      }
      dispatch(setLoading(false));
    } catch (e) {
      console.log(e);
    }
  };
};

export const loadVersionsCreator = (): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {
      auth: {ticketService},
    } = getState();

    try {
      const res = await ticketService.listVersions();
      if (res.parsedBody !== undefined) {
        dispatch(setVersions(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

